import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import { ROUTES } from '../../routes'

export interface CreateSessionButtonProps {
  /** Button text - defaults to "Create Session" */
  text?: string
  /** Additional CSS classes */
  className?: string
  /** Button variant - defaults to "primary" */
  variant?: 'primary' | 'secondary'
  /** Icon size - defaults to 24 */
  iconSize?: number
  /** Whether to show the plus icon - defaults to true */
  showIcon?: boolean
}

const CreateSessionButton: React.FC<CreateSessionButtonProps> = ({
  text,
  className = '',
  variant = 'primary',
  iconSize = 24,
  showIcon = true
}) => {
  const { t } = useTranslation()
  const resolvedText = text ?? t('sessions.createSession')
  const navigate = useNavigate()
  const location = useLocation()

  const handleCreateSession = () => {
    navigate(ROUTES.CREATE_SESSION, {
      state: { from: location.pathname }
    })
  }

  const buttonClass = `btn btn-${variant} ${className}`.trim()

  return (
    <button 
      className={buttonClass}
      onClick={handleCreateSession}
    >
      {showIcon && (
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="fill-current"
            d="M12 6C12.5523 6 13 6.44772 13 7V11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H11V7C11 6.44772 11.4477 6 12 6Z"
          />
        </svg>
      )}
      <span>{resolvedText}</span>
    </button>
  )
}

export default CreateSessionButton
